export const isEmpty = (value) => {
  if (value === undefined || value === null) return true;
  if (typeof value === "object" && Object.keys(value).length === 0) return true;
  return false;
};
